/**
 * Escape special characters for PostgREST/PostgreSQL ILIKE patterns.
 * Without escaping, characters like %, _, and \ change the meaning of the pattern.
 */
export function escapeIlike(value: string): string {
  return value
    .replace(/\\/g, '\\\\')
    .replace(/%/g, '\\%')
    .replace(/_/g, '\\_');
}

/**
 * Sanitize a search query for use in PostgREST .or() + ilike filters.
 * - Trims and limits length
 * - Escapes LIKE wildcards (%, _, \)
 * - Strips commas (PostgREST .or() separator)
 * Returns empty string if the result would be empty.
 */
export function sanitizeSearchQuery(value: string, maxLength = 100): string {
  const trimmed = value.trim().slice(0, maxLength);
  if (!trimmed) return '';
  return escapeIlike(trimmed).replace(/,/g, ' ');
}
